import React, {Component, Fragment} from 'react';
import './Header.css';


class Header extends Component {
  render() { 
    return (
        <Fragment>
            <header className="brand">
                <div className="brand-picture"></div>
                <p className="brand-name">Instagram</p>
            </header>
            <div className="help-user">Tap on any image to see product tags</div>
        </Fragment>
    );
  }
}

export default Header;




